import { useState, useContext, useEffect } from "react";
import { Box, Button } from "@mui/material";
import AddNewContact from "./AddNewContact";
import Backdrop from "@mui/material/Backdrop";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import EventIcon from "@mui/icons-material/Event";
import { ReactComponent as AddContact } from "../../../../Assets/img/icons/Vector1.svg";
import { ReactComponent as ID } from "../../../../Assets/img/icons/ID.svg";
import { ReactComponent as AddPeople } from "../../../../Assets/img/icons/Add people.svg";
import { ReactComponent as Manual } from "../../../../Assets/img/icons/Manual enter.svg";
import { ReactComponent as OutlookIcon } from "../../../../Assets/img/icons/outlook-icon.svg";
import { ReactComponent as GoogleIcon } from "../../../../Assets/img/icons/Google Logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ContactsDetContext } from "../../../ContactsDetContext";
import GoogleContacts from "./GoogleContacts";
import useApi from "../../../Utilities/useAPI";
import { useDispatch } from "react-redux";
import { getAllFoldersReducer } from "../../../../Redux/Reducers/ContactReducer";
import { useQuantityContext } from "../../../QuantityContext"

const SpeedDialComponent = () => {
   const { callApiFunction } = useApi();
  const { resetGroupDetails } = useContext(ContactsDetContext);
  const [open, setOpen] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [openAddContact, setOpenAddContact] = useState(false);
  const [importContact, setImportContact] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);

  const dispatch = useDispatch();

  const { handleSuccess, handleFailure } = useQuantityContext();

  const [googleTokenPresent, setGoogleTokenPresent] = useState(
    !!localStorage.getItem("g_token")
  );
  const [codeProcessed, setCodeProcessed] = useState(false);

  const navigate = useNavigate();

  const handleConnectClick = () => {
    navigate("/connect"); // navigates to the connect page
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmenu(false); // Hide submenu when main dial is closed
  };

  const handleAddContactClick = (event) => {
    event.stopPropagation(); // Prevent the click event from closing the SpeedDial
    setShowSubmenu(!showSubmenu); // Toggle submenu visibility
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const [newContact, setNewContact] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "+91",
    email: "",
    profile_url: "",
  });

  const submenuDisplay = showSubmenu ? "flex" : "none";

  const location = useLocation();

  const getToken = async (code) => {
    if (!code) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/google/token`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code }),
        }
      );
      const { access_token } = await response.json();

      if (access_token) {
        localStorage.setItem("g_token", access_token);
        setGoogleTokenPresent(true);
        setCodeProcessed(true);
        localStorage.removeItem("g_code");
        setImportContact(true);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (code && !codeProcessed && !googleTokenPresent) {
      localStorage.setItem("g_code", code);
      getToken(code);
      setCodeProcessed(true);
    }
  }, [location.search, codeProcessed, googleTokenPresent]);

  const handleLogin = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/google/auth`
      );
      const { url } = await res.json();
      window.location.href = url;
    } catch (error) {
      console.log(error);
    }
  };  

  const handleContactData = async () => {
    try {
      const updatedContacts = selectedContacts.map((data) => {
        const [firstname, lastname] = data.name.split(" ");

        // Add space between country code and phone number
        let phone = data.phone;
        if (phone && !phone.includes(" ")) {
          const countryCode = phone.slice(0, 3); // Assuming country code is 3 digits
          const restOfNumber = phone.slice(3);
          phone = `${countryCode} ${restOfNumber}`;
        }

        return {
          firstName: firstname,
          lastName: lastname,
          email: data.email,
          phone: phone,
        };
      });
      // Update the state or variable if needed
      setSelectedContacts(updatedContacts);
      setImportContact(false);
      // Log the transformed contacts
      // console.log("Received contacts:", updatedContacts);

      await callApiFunction("storeGoogleContacts", { contacts: updatedContacts });
      dispatch(getAllFoldersReducer());
      handleSuccess("Contacts Added Successfully!");
    } catch (error) {
      console.error("Error Adding Contacts:", error);
      handleFailure("Failed to Add to Contacts. Try again later.");
    }
  };

  return (
    <>
      <Box
        className="floating-dropdown-contacts"
        sx={{ position: "relative", zIndex: 1, height: "100vh" }}
      >
        <Backdrop open={open} onClick={handleClose} />

        <SpeedDial
          ariaLabel="SpeedDial tooltip example"
          sx={{ position: "fixed", bottom: 50, right: 50 }}
          icon={<SpeedDialIcon />}
          open={open}
          onClick={handleToggle}
          className={`parent ${showSubmenu ? "selected" : ""}`}
        >
          <SpeedDialAction
            key="Create Meet1"
            icon={<ID />}
            tooltipTitle="Import"
            tooltipOpen
            onClick={() => {
              setImportContact(true);
            }}
            style={{ display: submenuDisplay, color: "#0044c6", right: "76px" }}
            sx={{ color: "#0044C6" }}
            className="floating-customised-style"
          />
          <SpeedDialAction
            key="Create Meet2"
            icon={<Manual />}
            tooltipTitle="Manual"
            tooltipOpen
            onClick={() => {
              setOpenAddContact(true);
            }}
            style={{ display: submenuDisplay, color: "#0044c6", right: "76px" }}
            sx={{ color: "#0044C6" }}
            className="floating-customised-style"
          />
          <SpeedDialAction
            key="Create Meet3"
            icon={<AddPeople />}
            tooltipTitle="Connect"
            tooltipOpen
            onClick={handleConnectClick}
            style={{ display: submenuDisplay, color: "#0044c6", right: "76px" }}
            sx={{ color: "#0044C6" }}
            className="floating-customised-style"
          />
          <SpeedDialAction
            className={`floating-customised-style ${
              showSubmenu ? "selected" : ""
            }`}
            key="Add to Contact"
            icon={<ID />}
            tooltipTitle="Add to Contact"
            tooltipOpen
            onClick={handleAddContactClick}
            // className={`floating-customised-style ${showSubmenu ? 'selected' : ''}`}
          />
          <SpeedDialAction
            key="Create Meet"
            icon={<EventIcon />}
            tooltipTitle="Create Meet"
            tooltipOpen
            onClick={handleClose}
            style={{ color: "#0044c6" }}
            sx={{ color: "#0044C6" }}
            className="floating-customised-style"
          />

          <SpeedDialAction
            key="Create Group"
            icon={<AddContact />}
            tooltipTitle="Create Group"
            tooltipOpen
            onClick={() => {
              navigate("/create_group");
              resetGroupDetails();
            }}
            style={{ color: "#0044c6" }}
            sx={{ color: "#0044C6" }}
            className="floating-customised-style"
          />
        </SpeedDial>
      </Box>
      <AddNewContact
        openAddContact={openAddContact}
        setOpenAddContact={setOpenAddContact}
        newContact={newContact}
        setNewContact={setNewContact}
      />

      {importContact && (
        <>
          <div className="lightbox-overlay">
            <div className="lightbox-content-2 thin-lightbox">
              <div className="active-component-container">
                <div className="d-flex justify-content-between">
                  <div className="card-edit-info-heading">
                    <h6 className="text-left fw-bold">Import/Sync Contacts</h6>
                    {!googleTokenPresent && (
                      <span className="sub-text-lightbox">
                        Sync your contacts easily by choosing one of the options
                        below.
                      </span>
                    )}
                  </div>
                  <button
                    className="lightbox-close pointer"
                    onClick={() => setImportContact(false)}
                  >
                    &times;
                  </button>
                </div>
                {!googleTokenPresent ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<GoogleIcon />}
                      style={{
                        textTransform: "none",
                        width: "48%",
                        borderColor: "#00000066",
                        color: "#00000099",
                        height: "48px",
                      }}
                      onClick={handleLogin}
                    >
                      Import from Google
                    </Button>

                    <Button
                      variant="outlined"
                      startIcon={<OutlookIcon />}
                      style={{
                        textTransform: "none",
                        width: "48%",
                        borderColor: "#00000066",
                        color: "#00000066",
                        height: "48px",
                      }}
                    >
                      Import from Outlook
                    </Button>
                  </div>
                ) : (
                  <>
                    <GoogleContacts setSelectedContacts={setSelectedContacts} /> 
                    <div>
                      <Button
                        className="me-2"
                        variant="contained"
                        sx={{ backgroundColor: "#0044C6" }}
                        onClick={handleContactData}
                        disabled={selectedContacts.length === 0}
                      >
                        ADD TO CONTACTS
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SpeedDialComponent;
